import { EventEmitter } from "@angular/core";
import { ButtonDownloadCheckComponent, ButtonsActionsTableComponent, CheckTableComponent, InputTableComponent } from "@app/shared";
import { environment } from '@env/environment';

export class StampConfigService{
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Contiene la configuracion de la tabla
  settings = {};
  constructor() {
    const self = this;
    if (environment.stickersAvanzados){
      this.settings = {
        mode: 'external',
        actions: false,
        noDataMessage: 'No hay rótulos para el tipo de documental seleccionado',
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          nombre: {
            editable: false,
            addable: false,
            title: 'Nombre',
            filter: {
              inputClass: 'form-control',
            }
          },
          rotulo: {
            editable: false,
            addable: false,
            title: 'Rótulo',
            type: 'custom',
            renderComponent: ButtonDownloadCheckComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                const sendData = {
                  'action': 'descargar',
                  'data': data
                };
                self.accion.emit(sendData);
              });
            },
          },
          posicion_x:{
            editable: false,
            addable: false,
            title: 'Posición horisontal',
            filter: {
              inputClass: 'form-control',
            }
          },
          posicion_y:{
            editable: false,
            addable: false,
            title: 'Posición vertical',
            filter: {
              inputClass: 'form-control',
            }
          },
          ancho:{
            editable: false,
            addable: false,
            title: 'Ancho',
            filter: {
              inputClass: 'form-control',
            }
          },
          imprimir:{
            editable: false,
            addable: false,
            title: 'Tipo impresión',
            type: 'custom',
            renderComponent: CheckTableComponent,
            filter: {
              inputClass: 'form-control',
              type: 'checkbox',
              config: {
                true: 'Sí',
                false: 'No',
                resetText: 'Todo',
              },
            },
          },
          
          acciones: {
            title: 'Acciones',
            filter: false,
            sort: false,
            type: 'custom',
            renderComponent: ButtonsActionsTableComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // Controla el evento click del boton
                self.accion.emit(data);
              });
            }
          },
        }
      };
    }else{
      this.settings = {
        mode: 'external',
        actions: false,
        noDataMessage: 'No hay rótulos para el tipo de documental seleccionado',
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          nombre: {
            editable: false,
            addable: false,
            title: 'Nombre',
            filter: {
              inputClass: 'form-control',
            }
          },
          rotulo: {
            editable: false,
            addable: false,
            title: 'Rótulo',
            type: 'custom',
            renderComponent: ButtonDownloadCheckComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                const sendData = {
                  'action': 'descargar',
                  'data': data
                };
                self.accion.emit(sendData);
              });
            },
          },
          acciones: {
            title: 'Acciones',
            filter: false,
            sort: false,
            type: 'custom',
            renderComponent: ButtonsActionsTableComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // Controla el evento click del boton
                self.accion.emit(data);
              });
            }
          },
        }
      };
    }
   
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/documents/stamp/shared/stamp-config.service.ts